"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRemoteImageSrc = useRemoteImageSrc;
var _react = require("react");
var _remoteImageFallbackSrc = require("@cbhq/cds-common/media/remoteImageFallbackSrc");
function useRemoteImageSrc(spectrum, src) {
  return (0, _react.useMemo)(() => {
    const remoteImageFallbackSrc = spectrum === 'dark' ? _remoteImageFallbackSrc.remoteImageDarkFallbackSrc : _remoteImageFallbackSrc.remoteImageLightFallbackSrc;
    return src !== null && src !== void 0 ? src : remoteImageFallbackSrc;
  }, [spectrum, src]);
}